<template>
  <video v-if="videoFile" class="video-component" controls>
    <source :src="videoFile" type="video/mp4">
  </video>
  <iframe v-else class="video-component" type="text/html" v-bind:src="video_source" allowFullScreen></iframe> 
</template>

<script>
  export default {
    props: ['video', 'videoFile'],
    computed: {
      video_source () {

        // if url is formatted correctly, return
        if (this.video.indexOf('embed') !== -1) return this.video

        // otherwise, change to embed
        let embed_prefix = 'https://www.youtube.com/embed/'
        let url_string = this.video.split('/')
        let url_source = url_string[url_string.length -1].replace('watch?v=', '')

        return embed_prefix + url_source

      }
    }
  }
</script>

<style scoped lang="scss">

  .video-component {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
  }

</style>


// WEBPACK FOOTER //
// video_component.vue?aac46026